<app-mu-table
  contextLang="massive.requests"
  [columns]="tableListColumns"
  [responsive]="true"
  [flags]="flags"
  [flagEmpty]="massiveRequestFlags.LOAD_REQUEST_TABLE"
  [dataList]="dataList"
  [paginator]="true"
  [filters]="filters"
>
  <ng-template appMuTableCaption>
    <div class="p-col-12 p-md-5 p-lg-4 p-xl-3">
      <app-mu-button
        label="{{ 'context.massive.requests.load_excel' | translate }}"
        [flag]="massiveRequestFlags.SHOW_UPLOAD_EXCEL_PAGE"
        [flagList]="flags"
      ></app-mu-button>
    </div>
  </ng-template>

  <ng-template [appMuTableFilter]="'status'" let-column>
    <p-dropdown [options]="statuses" [(ngModel)]="filters.model[column.filter]"> </p-dropdown>
  </ng-template>

  <ng-template [appMuTableCell]="'routed'" let-column let-row="row">
    <span [innerHTML]="'context.massive.requests.routedState.' + column.getValue(row) | translate"></span>
  </ng-template>

  <ng-template [appMuTableCell]="'options'" let-column let-row="row">
    <app-mu-table-options
      [data]="row"
      [tableOptionList]="tableOptionList"
      [showAlways]="true"
      [permissionList]="getPermissionList(row)"
      [actions]="actions"
    ></app-mu-table-options>
  </ng-template>

  <ng-template [appMuTableCell]="" let-column let-row="row">
    {{ column.getValue(row) }}
  </ng-template>
</app-mu-table>
